<template>
    <div>
        <template v-if="assessmentCanStart">
            <h2>{{ measure.Name }}</h2>

            <p>{{ pre }}</p>
            <p>{{ item }}</p>
            <p>{{ post }}</p>

            <div class="question-holder">
                <ul v-if="responseOptions.length > 0">
                    <li
                        v-for="option in responseOptions"
                        :key="option.ResponseID"
                    >
                        <label>
                            <input
                                v-model="chosenResponseOption"
                                type="radio"
                                name="kappa"
                                :value="option.ResponseID"
                            >
                            {{ option.Description }}
                        </label>
                    </li>
                </ul>
            </div>

            <div v-if="responseOptions.length === 0 && score.length === 0">
                Geen response options
            </div>

            <div v-if="score.length > 0">
                <pre>
                    {{ JSON.stringify(score, null, 4) }}
                </pre>
                <br><br>
                <RouterLink
                    :to="{ name: 'choose_measure' }"
                >
                    Nieuwe assessment
                </RouterLink>
                <br><br>
            </div>

            <button
                :disabled="!canGoBack"
                @click="goBack"
            >
                Terug
            </button>
        </template>

        <template v-else>
            Geen assessment gevonden;
            <RouterLink
                :to="{ name: 'choose_measure' }"
            >
                klik hier om terug te gaan
            </RouterLink>.
        </template>
    </div>
</template>

<script>
export default {
    name: 'Assessment',

    data() {
        return {
            chosenResponseOption: null,
        };
    },

    computed: {
        assessmentCanStart() {
            return this.item !== '' || this.score.length > 0;
        },
        measure() {
            return this.$store.state.measures.measure;
        },
        pre() {
            return this.$store.getters['assessment/pre'];
        },
        item() {
            return this.$store.getters['assessment/item'];
        },
        post() {
            return this.$store.getters['assessment/post'];
        },
        score() {
            return this.$store.getters['assessment/score'];
        },
        responseOptions() {
            return this.$store.getters['assessment/responseOptions'];
        },
        canGoBack() {
            return this.$store.state.assessment.answers.length > 1;
        },
    },

    watch: {
        chosenResponseOption(newValue) {
            if (!newValue) {
                return;
            }

            this.$store.dispatch('assessment/answer', newValue);
            this.chosenResponseOption = null;
        },
    },

    methods: {
        goBack() {
            this.$store.dispatch('assessment/back');
        },
    },
};
</script>

<style>
.question-holder {
  display: flex;
  justify-content: center;
  align-items: center;
}
li {
  text-align: left;
}
</style>
